<div>
    <mat-progress-bar *ngIf="isLoadingEnable" mode="indeterminate"></mat-progress-bar>
</div>
